import { onDomReady } from '../utils/dom';
import { DropdownMenu } from '../utils/dropdown-menu';

/**
 * @typedef MenuOptions
 * @property {string} selector
 * @property {string} navButton
 * @property {{ element: string, close: string }} [overlay]
 */

const MainMenu = {
    selector: '#header .main-nav',
    navButton: '#header .nav-button',
    overlay: {
        element: '#nav-overlay',
        close: '#nav-close',
    },
};

/* Die Navigation wandert je nach Viewport zwischen Header-Leiste und Menü-Dialog */
function moveMainNav() {
    const mainNav = document.getElementById('main-nav-wrapper');
    const navContent = document.getElementById('nav-content');
    const header = document.querySelector('#header .header_inside');
    const navButton = document.querySelector(MainMenu.navButton);

    if (!mainNav || !navContent || !header || !navButton) return;

    // Achtung: der Dialog selbst liegt innerhalb von .header_inside — daher auf #nav-content prüfen
    if (getComputedStyle(navButton).display !== 'none') {
        if (!mainNav.closest('#nav-content')) {
            // vor Treffpunkt/Kontakt einhängen, damit der Block unter der Navigation bleibt
            navContent.insertBefore(mainNav, document.getElementById('nav-overlay-contact'));
        }
    } else if (mainNav.closest('#nav-content')) {
        header.append(mainNav);
    }
}

onDomReady(() => {
    moveMainNav();
    new DropdownMenu(MainMenu);
});

window.addEventListener('resize', moveMainNav);
